/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import styled from '@emotion/styled';
import { FormControl } from '@mui/material';

export const StyledFormControl = styled(FormControl, {
  shouldForwardProp: (prop: string) => prop !== 'maxWidth',
})<{ maxWidth?: string | number }>(({ maxWidth }) => ({
  ...(maxWidth && { maxWidth }),
}));
